import { generateCommonQueryString } from '../../../../Shared/React/js/utils/CommonQueryString';

const appendQueryParam = WhistleOut.appendQueryParam;

// TODO: Try reducing cyclomatic complexity and enable the eslint rule
// eslint-disable-next-line complexity
export function generateQueryString(
    /**@type {{common: import('../../../../Shared/js/@types/SearchCriteriaCommon').SearchCriteriaCommon;}} */ data,
    allTabletPriceTypes,
    /** @type {boolean} */ isEmbed
) {
    let queryString = '';

    if (data.location) {
        queryString = appendQueryParam(queryString, 'location=' + data.location);
    }

    if (data.minimumData) {
        queryString = appendQueryParam(queryString, 'data=' + data.minimumData);
    }

    if (data.tabletShortUrl && data.tabletShortUrl.length > 0) {
        queryString = appendQueryParam(queryString, 'tablet=' + data.tabletShortUrl);
    }

    if (data.includeSimOnly === true) {
        queryString = appendQueryParam(queryString, 'simonly=true');
    }

    if (data.simType) {
        queryString = appendQueryParam(queryString, 'simtype=' + data.simType);
    }

    if (!allTabletPriceTypes && data.tabletPriceTypes && data.tabletPriceTypes.length) {
        queryString = appendQueryParam(queryString, 'tabletprice=' + data.tabletPriceTypes.sort().join(','));
    }

    if (
        (data.maximumTabletUpfrontCost || data.maximumTabletUpfrontCost === 0) &&
        data.maximumTabletUpfrontCost !== -1
    ) {
        queryString = appendQueryParam(queryString, 'maxupfront=' + data.maximumTabletUpfrontCost);
    }

    if (data.compareUnthrottledData === false || data.compareUnthrottledData === 'false') {
        queryString = appendQueryParam(queryString, 'fullspeeddata=false');
    }

    if (data.prepaidExpiryDays) {
        queryString = appendQueryParam(queryString, 'prepaidexpiry=' + data.prepaidExpiryDays);
    }

    if (data.maximumPrepaidExpiryDays) {
        queryString = appendQueryParam(queryString, 'maxprepaidexpiry=' + data.maximumPrepaidExpiryDays);
    }

    if (data.planTypes && data.planTypes.length) {
        queryString = appendQueryParam(queryString, 'type=' + data.planTypes.sort().join(','));
    }

    if (data.networkIds && data.networkIds.length) {
        queryString = appendQueryParam(queryString, 'network=' + data.networkIds.sort().join(','));
    }

    if (data.common) {
        const commonQueryString = generateCommonQueryString(data.common, isEmbed);
        if (commonQueryString.length > 0) {
            queryString = appendQueryParam(queryString, commonQueryString);
        }
    }

    return queryString;
}
